<div class="tab-content">
  <div class="button-return">
    <app-button
      type="button"
      color="return"
      icon="agres-return"
      (btnClick)="goBack()"
      title="{{ 'global.back' | translate }}">
    </app-button>
  </div>

  <h3 class="field__section-title">{{ 'data-exchange.my-connections-title' | translate }}</h3>
  <h4 class="field__section-subtitle">
    {{ 'agrirouter.title' | translate }}
  </h4>
  <div class="field__info">
    <span [innerHTML]="'data-exchange.info-1' | translate">
    </span>
  </div>
  <div class="field__info">
    <span [innerHTML]="'data-exchange.info-2' | translate">
    </span>
  </div>
  <div class="agrirouter-card">
    <div class="agrirouter-card__header">
      <div class="agrirouter-card__logo">
        <img src="assets/images/agrirouter/agrirouter.svg" alt="agrirouter" />
      </div>
      @if(userHasOnboarded){
      <div class="agrirouter-card__status">
        <span class="agrirouter-card__connection agrirouter-card__connection--online">{{'data-exchange.online' |
          translate}}</span>
        @if(certificateExpiresAt){
        <span class="agrirouter-card__datetime">
          {{ 'data-exchange.certificate-expires' | translate }}:
          {{ certificateExpiresAt | date: 'mediumDate' : '' : currentLocale }}
        </span>
        }
      </div>
      }@else {
      <div class="agrirouter-card__status">
        <span class="agrirouter-card__connection agrirouter-card__connection--offline">{{'data-exchange.offline' |
          translate}}</span>
      </div>
      }
    </div>

    @if(userHasOnboarded){
    <app-button (btnClick)="offboardAccount()" title="{{ 'data-exchange.disconnect' | translate }}" size="full"
      color="danger" icon="agres-close"></app-button>
    <app-button (btnClick)="triggerAgrirouterIntegration()" title="{{ 'global.reconnect' | translate }}" size="full"
      icon="agres-reload"></app-button>
    }@else {
    <app-button (btnClick)="triggerAgrirouterIntegration()" title="{{ 'global.connect' | translate }}" size="full"
      icon="agres-plus"></app-button>
    }

  </div>

  <h3 class="field__section-title">{{ 'data-exchange.my-devices-title' | translate }}</h3>
  <h4 class="field__section-subtitle">
    {{ 'agrirouter.title' | translate }}
  </h4>
  <div class="field__info">
    <span [innerHTML]="'data-exchange.info-3' | translate">
    </span>
  </div>
  <div class="field__info">
    <span [innerHTML]="'data-exchange.info-4' | translate">
    </span>
  </div>

  <div class="device-list">
    @for (device of devicesToOnboard; track $index) {
      <div
        class="device-card"
        [ngClass]="{ 'device-card--online': device.onboarded, 'device-card--offline': !device.onboarded }">
        <div class="device-card__header">
          <div class="device-card__icon">
            <i class="agres-fleet-monitoring"></i>
          </div>

          <div class="device-card__info">
            <h2>{{ device.id }}</h2>
            <span class="device-card__name">{{ device.labelKey | translate }}</span>
          </div>

          <div class="device-card__status">
            @if (device.onboarded) {
              <span class="device-card__connection device-card__connection--online">
                {{ 'data-exchange.online' | translate }}
              </span>
            } @else {
              <span class="device-card__connection device-card__connection--offline">
                {{ 'data-exchange.offline' | translate }}
              </span>
            }
          </div>
        </div>

        <div class="device-card__footer">
          @if (device.onboarded) {
            <app-button
              (btnClick)="offboardVCU(device)"
              title="{{ 'data-exchange.disconnect' | translate }}"
              size="full"
              [disabled]="!userHasOnboarded"
              color="danger"
              icon="agres-close"></app-button>
          } @else {
            <app-button
              (btnClick)="onboardVCU(device)"
              title="{{ 'global.connect' | translate }}"
              size="full"
              [disabled]="!userHasOnboarded"></app-button>
          }
        </div>
      </div>
    }
  </div>

  <h3 class="field__section-title">
    {{ 'data-exchange.my-files' | translate }}
  </h3>

  <h4 class="field__section-subtitle">
    {{ 'agrirouter.title' | translate }}
  </h4>

  <div class="field__info">
    <span [innerHTML]="'data-exchange.info-5' | translate"></span>
  </div>
  <div class="field__info">
    <span [innerHTML]="'data-exchange.info-6' | translate"></span>
  </div>

  <div class="button-right mb-3">
    <app-button (btnClick)="getShapefiles()" title="{{'agrirouter.messages.import-files' | translate}}" color="primary"
      icon="agres-download" [disabled]="!userHasOnboarded">
    </app-button>
  </div>

  <!-- Lista de arquivos agrupados -->
  <div *ngFor="let group of files | keyvalue">
    <h4 class="field__section-serial">{{ group.key }}</h4>

    <div class="files-row">
      <div *ngFor="let file of group.value" class="files-card">
        <div class="files-card__header">
          <div class="files-card__info">
            <div class="files-card__name">{{ file }}</div>
          </div>
        </div>

        <div class="files-card__footer">
          <app-button (btnClick)="downloadFile(group.key, file)" title="{{'global.download' | translate}}"
            color="primary" icon="agres-download" size="full">
          </app-button>
          <app-button (btnClick)="deleteFile(group.key, file)" title="{{'global.delete' | translate}}" color="danger"
            icon="agres-close" size="full">
          </app-button>
        </div>
      </div>
    </div>
  </div>
  <br />
  <br>
</div>